
import {
  QualityControlAssignmentDto,
  CreateQualityControlAssignmentDto,
  UpdateQualityControlAssignmentDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type QualityControlAssignmentsFilters = PaginatedQueryBase & {
  includeInactive?: boolean
}

class QualityControlAssignmentService extends BaseCrudService<
  QualityControlAssignmentDto,
  CreateQualityControlAssignmentDto,
  UpdateQualityControlAssignmentDto,
  QualityControlAssignmentsFilters
> {
  constructor() {
    super('quality-control-assignment', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const qualityControlAssignmentService = new QualityControlAssignmentService()
